var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBrushRegular = function SvgBrushRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 14.102c-.547.683-1.34 1.12-2.215 1.148 0 .082.027.164.027.219a3.273 3.273 0 0 1-3.28 3.281H5a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875h.164c.492 0 .82-.52.738-1.012a3.028 3.028 0 0 1-.054-.52 3.29 3.29 0 0 1 3.28-3.28c.083 0 .165.027.247.027.027-.875.465-1.668 1.148-2.215l6.536-4.894c.683-.52 1.668-.438 2.296.164.602.628.684 1.586.165 2.296l-4.895 6.536Zm-2.926-3.336 2.16 2.133 4.594-6.126c.137-.164.11-.41-.027-.574-.164-.136-.41-.164-.574-.027l-6.153 4.594Zm-2.133 2.789c-.136-.028-.273-.055-.41-.055a1.978 1.978 0 0 0-1.969 1.969v.328c.11.574-.054 1.176-.355 1.64h-.027 2.351a1.978 1.978 0 0 0 1.969-1.968c0-.137-.027-.274-.055-.41l-1.504-1.504Z"
  })));
};

export default SvgBrushRegular;